import { gql } from '@apollo/client'

export default gql`
    mutation campaign($Name: String, $Priority: String, $CampaignID: String!, $Status: String, $Copy: String, $Subject: String, $Values: String, $Doc: String, $Logic: String, $Description: String) {
        campaign(Name: $Name, Priority: $Priority, CampaignID: $CampaignID, Status: $Status, Copy: $Copy, Subject: $Subject, Values: $Values, Doc: $Doc, Logic: $Logic, Description: $Description) 
    }
`
